import Avatar from '@mui/material/Avatar';
import { useMemo } from 'react';

import FlagCHL from '@/assets/common/flags/flag_chile.svg';
import FlagCOL from '@/assets/common/flags/flag_colombia.svg';
import FlagMEX from '@/assets/common/flags/flag_mexico.svg';
import FlagPER from '@/assets/common/flags/flag_peru.svg';
import { Countries } from '@/utils/common';

interface FLAGProps {
  country: Countries;
  height?: number;
  width?: number;
}

const Flag = ({ height = 50, width = 50, country }: FLAGProps) => {
  const flag = useMemo(() => {
    switch (country) {
      case 'MEX':
        return FlagMEX;
      case 'CHL':
        return FlagCHL;
      case 'PER':
        return FlagPER;
      case 'COL':
        return FlagCOL;
      default:
        return FlagMEX;
    }
  }, [country]);

  return <Avatar src={flag} sx={{ height, width }} />;
};

export default Flag;
